import { render, staticRenderFns } from "./AwardVoteCard.vue?vue&type=template&id=0796893e&scoped=true&"
import script from "./AwardVoteCard.vue?vue&type=script&lang=js&"
export * from "./AwardVoteCard.vue?vue&type=script&lang=js&"
import style0 from "./AwardVoteCard.vue?vue&type=style&index=0&id=0796893e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0796893e",
  null
  
)

export default component.exports